import { render, staticRenderFns } from "./FolderHistory.vue?vue&type=template&id=e8e54602&"
import script from "./FolderHistory.vue?vue&type=script&lang=ts&"
export * from "./FolderHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports